import { SubProject } from '../model/project/sub-project';
import { EditProjectComponent } from '../pages/projects/edit/edit-project.component';
import { EditIPAdjustmentComponent } from '../components/adjustments/edit-ip-adjustment/edit-ip-adjustment.component';

export default class ComponentHelper {
  static getComponentClassFor(model: SubProject): any {
    if (model.type == 'Adjustment') {
      return EditIPAdjustmentComponent;
    } else if (model.type == 'SoldRented') {
      return EditIPAdjustmentComponent;
    } else if (model.type == 'Repo') {
      return EditIPAdjustmentComponent;
    } else if (model.type == 'BaseProject') {
      return EditProjectComponent;
    } else {
      console.error('No content component class found for model', model);
      return null;
    }
  }
}
